import React, { useContext, useEffect } from "react";
import { HeaderContext } from "../../../../../HeaderContext";
import "../_okr-plans-coach.scss";

// The frame every live coach OKR Plans screen sits in: header title, the
// coach palette sheet, `opc-live`.
const OpcShell = ({ children }) => {
  const HeaderMetaData = useContext(HeaderContext);
  useEffect(() => {
    document.title = "Art of Scale | OKR Plans";
    HeaderMetaData.setHeaderMetadata({ headerTitle: "OKR Plans" });
    // eslint-disable-next-line
  }, []);
  return (
    <div id="okr-plans-coach" className="opc-live">
      {children}
    </div>
  );
};

export default OpcShell;
